/**
 * GutenDevTheme scripts (footer)
 * This file contains any js scripts you want added to the theme's footer. 
 */

// START CUSTOM JS ---------------------------------------

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// init Testimonial Swiper:
const swiper = new Swiper('.testimonial-swiper', {
  modules: [ Navigation, Pagination ],
  slidesPerView: 1,
  loop: true,
  mousewheel: true,
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
  },
});


// init Image Caoursel Swiper:
const swiper2 = new Swiper('.image-swiper', {
  modules: [ Navigation, Pagination, Autoplay ],
  slidesPerView: 1,
  rewind: true,
  mousewheel: true,
  centerInsufficientSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination2",
  },
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    // when window width is >= 520px
    520: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30
    }
  }
});

// END CUSTOM JS ---------------------------------


// START CUSTOM JQUERY DOC READY ---------------------------------

jQuery( document ).ready(function( $ ) {

  // modal menu init
  var modal_menu = $("#c-modal-nav-button").totalModal({
    modalTarget: '#modal-navigation',
    modalClose: '#close-total-modal',
    animatedIn: 'animate__slideInDown',
    animatedOut: 'animate__slideOutUp',
    animationDuration: '444ms',
    color: '#FFF',
    afterOpen : function() {
      document.getElementById('modal-navigation').focus();
    },
    afterClose: function() {
      $( '#modal-navigation' ).addClass( 'is-hidden' )
      $( 'body, html' ).css({ 'overflow': '' });
    }
  });

  // modalExtras() - just some stuff to make the modal menu better
  function modalExtras() {
    // get last and current hash + update on hash change
    var currentHash = function() {
      return location.hash.replace(/^#/, '')
    }
    var last_hash
    var hash = currentHash()
    $(window).bind('hashchange', function(event) {
      last_hash = hash;
      hash = currentHash();
    });
  
    // enable back/foward to close/open modal
    $("#c-modal-nav-button").on('click', function(){ window.location.href = ensureHash("#menu"); });
    function ensureHash(newHash) {
      if (window.location.hash) {
        return window.location.href.substring(0, window.location.href.lastIndexOf(window.location.hash)) + newHash;
      }
      return window.location.hash + newHash;
    }
  
    // if back button is pressed, close the modal
    $(window).on('hashchange', function (event) {
      if (last_hash == 'menu' && hash == '') {
        modal_menu.close();
        history.replaceState('', document.title, window.location.pathname);
      } // if forward button, open the modal
      else if (window.location.hash == "#menu"){
        modal_menu.open();
      }
    });
  
    // if close button is clicked, clear the #menu hash added above
    $('#close-total-modal').on('click', function (e) {
      history.replaceState('', document.title, window.location.pathname);
    });
  
    // close modal menu if esc key is used
    $(document).keyup(function (e) {
      if( e.keyCode == 27 && hash == 'menu' ) {
        window.history.back();
      }
    });
  }
  modalExtras();


  // accordion for main (modal) menu navigation -------------------------
  $( '.c-modal-menu .menu-item-has-children > a .expand-icon' ).on( 'click', function (ev) {
    ev.preventDefault();
    $(this).parent().parent().toggleClass( 'is-active' );
    $(this).next('.sub-menu').toggleClass( 'is-expanded' );
  });
  

});
// END CUSTOM JQUERY DOC READY ------------------------------
